import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { cn } from '../../../lib/utils';
import { SpecraEmptyState } from '../lieutenants/empty-state';
import { SpecraFileRow } from '../lieutenants/file-row';
/** Document and attachment collection shared by docs and delivery evidence. */ export function SpecraFileList({ className, emptyAction, emptyTitle = 'No files', files, getItemProps, getItemTestId, ...props }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('divide-y divide-border', className),
        ...props,
        children: [
            files.map((file)=>{
                const { id, ...row } = file;
                return /*#__PURE__*/ _createElement(SpecraFileRow, {
                    ...row,
                    ...getItemProps?.(file),
                    "data-item-id": id,
                    "data-testid": getItemTestId?.(file),
                    key: id
                });
            }),
            files.length === 0 ? /*#__PURE__*/ _jsx(SpecraEmptyState, {
                action: emptyAction,
                title: emptyTitle
            }) : null
        ]
    });
}
